import { useState } from "react";
import { Link } from "react-router-dom";
import { projects } from "../projects/index";
import { useMediaQuery } from "../utils/useMediaQuery";

export function WorkOverview({ onNavigate, isVisible }) {
  const shortenInitiated = useMediaQuery(
    "(min-width: 600px) and (max-width: 1200px)"
  );
  const hideYear = useMediaQuery("(min-width: 600px) and (max-width: 960px)");
  const shortenDisciplines = useMediaQuery(
    "(min-width: 600px) and (max-width: 710px)"
  );
  const [hoveredImage, setHoveredImage] = useState(null);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  const handleMouseEnter = (images) => {
    setHoveredImage(images);
  };

  const handleMouseLeave = () => {
    setHoveredImage(null);
  };

  const handleMouseMove = (e) => {
    setMousePos({ x: e.clientX, y: e.clientY });
  };

  return (
    <div className="work-menu">
      <div className="work-menu-head grid-twelve-cols-lg grid-four-cols-sm">
        <p className="meta-title start-one-lg span-four-lg">Disciplines</p>
        {!hideYear && (
          <p className="meta-title start-five-lg span-one-lg start-one-sm span-one-sm">
            Year
          </p>
        )}
        <p className="meta-title start-six-lg span-four-lg start-two-sm span-three-sm">
          Project
        </p>
        <p className="meta-title start-ten-lg span-three-lg overview-initiated-at">
          Initiated at
        </p>
      </div>
      <ul className="work-menu-list">
        {projects.map((item) => (
          <li
            key={item.id}
            className="work-row"
            onMouseEnter={() => handleMouseEnter(item.thumbnailUrl)}
            onMouseLeave={handleMouseLeave}
            onMouseMove={handleMouseMove}
          >
            <Link
              to={`/projects/${item.id}`}
              onClick={onNavigate}
              className="grid-twelve-cols-lg grid-four-cols-sm"
              tabIndex={isVisible ? 0 : -1}
            >
              <p
                className={
                  hideYear
                    ? "meta-description start-one-lg span-four-lg span-five-md no-wrap-text"
                    : "meta-description start-one-lg span-four-lg no-wrap-text"
                }
              >
                {shortenDisciplines && item.shortDisciplines
                  ? item.shortDisciplines
                  : item.disciplines}
              </p>
              {!hideYear && (
                <p className="meta-description start-five-lg span-one-lg no-wrap-text start-one-sm span-one-sm">
                  {item.year}
                </p>
              )}
              <p className="meta-description start-six-lg span-four-lg no-wrap-text start-two-sm span-three-sm">
                {shortenDisciplines
                  ? item.project.startsWith("The ")
                    ? item.project.slice(4)
                    : item.project
                  : item.project}
              </p>
              <p className="meta-description start-ten-lg span-three-lg no-wrap-text overview-initiated-at">
                {shortenInitiated ? item.shortInitiatedAt : item.initiatedAt}
              </p>
            </Link>
          </li>
        ))}
      </ul>

      {hoveredImage && (
        <div
          className="hover-preview"
          style={{
            top:
              mousePos.y -
              (shortenInitiated
                ? ((window.innerWidth - 260) / 12) * 3 + 40
                : ((window.innerWidth - 260) / 12) * 2 + 20),
            left: mousePos.x,
          }}
        >
          <img src={hoveredImage} alt="preview" />
        </div>
      )}
    </div>
  );
}
